import { Component, OnInit } from '@angular/core';
import { EnforcementService } from 'src/app/Services/enforcement.service';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-violations',
    templateUrl: './violations.component.html',
    styleUrls: ['./violations.component.scss'],
    standalone: false
})
export class ViolationsComponent implements OnInit {
  public ShowPermitFilter = false;
  public ShowRatesFilter = false;
  constructor(private permissionsService : PermissionsService, public enforcementService : EnforcementService) { }

  public Columns : Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("ID", "Id"),
    new Datalistviewcolumn("Status", "Status"),
    new Datalistviewcolumn("Detection Source", "DetectionSource"),
    new Datalistviewcolumn("Detected", "StartDateAsString"),
    new Datalistviewcolumn("Closed", "EndDateAsString"),
    new Datalistviewcolumn("Location", "LocationString"),
    new Datalistviewcolumn("Plate", "PlateNumber"),
    new Datalistviewcolumn("Violation Duration", "ViolationDurationAsString"),
    new Datalistviewcolumn("Review Notes", "ReviewNotes")
  ];

  async ngOnInit(): Promise<void> {
  }

}
